/** @deprecated It's not needed for universal types */
export const throwable = {};
/** @deprecated Use type() instead */
export function createType({ getPlain, getTyped, isArray, }) {
    const getType = (fallback) => {
        const validFallback = fallback !== throwable ? getTyped(getPlain(fallback)) : fallback;
        return {
            getPlain: getPlain,
            getTyped: (plainValue) => {
                try {
                    return getTyped(plainValue);
                }
                catch (error) {
                    if (validFallback !== throwable) {
                        return validFallback;
                    }
                    throw [error, throwable];
                }
            },
            isArray,
        };
    };
    return Object.assign(getType, { getPlain, getTyped, isArray });
}
